import { Result } from "appworks/model/gameplay/records/results/result";
import { Point } from "appworks/utils/geom/point";

export class SymbolWinResult extends Result {

    /** For debugging purposes */
    public resultType: string = "SymbolWinResult";

    /** SymbolId */
    public symbolType: string;

    public symbols: string[] = [];

    public matches: number;

    public positions: Point[];

    // Optional array of multipliers applied to each symbol, which can be used for various games types
    // e.g Games with multiplier wilds, split symbols
    // This array has no influence on anything else in the object (matches, cashWon etc)
    public multipliers: number[];

    public ofAKind(): number {
        return Math.max(...(this.positions.map((p) => p.x))) + 1;
    }
}
